export default __webpack_public_path__ + "static/media/logo.944f1a28.svg";